import { beMessApiGenerateThumbnail } from 'Api/BeMessApi'
import { collaborationApiGetAccountProjects } from 'Api/collaborationApi'
import {
  COLLABORATION_PROJECT_STATUS_APPROVED,
  COLLABORATION_PROJECT_STATUS_ARCHIVED,
  COLLABORATION_PROJECT_STATUS_OPEN,
  MESSAGE_MAX_ATTACHMENTS
} from 'Constants/index'
import { logAppError } from 'Helpers/logger'
import noImagePreviewBackground from 'Img/no-image-preview-backgroud.png'
import { atom, selector, selectorFamily } from 'recoil'

export const messageState = atom({
  key: 'overviewMessageMessageState',
  default: {
    id: undefined,
    isDirty: false,
    isSending: false,
    hasThumbnail: true,
    imageCheckFail: false,
    checkup: undefined,
    canSend: false,
    canQuickSend: false,
    messageType: undefined,
    isBee: undefined,
    idCampaign: undefined,
    notes: '',
    preHeader: '',
    tags: [],
    subject: '',
    useDynamicField: false,
    fields: [],
    embed: false,
    embedItems: undefined,
    customParams: '',
    trackingInfoEnabled: false,
    trackingInfoProtocols: [],
    endpointsToggle: false,
    selectedEndpointsList: [],
    baseEndpoint: undefined,
    isSubjectDirty: false,
    linkedForms: [],
    linkedEntities: [],
    isUsed: false
    // isSaved: false
  }
})

export const overviewThumbnailState = atom({
  key: 'overviewMessage__overviewThumbnailState',
  default: {
    url: noImagePreviewBackground,
    status: 'loading'
  }
})

export const subjectValidState = selector({
  key: 'overviewMessageSubjectValidState',
  get: ({ get }) => {
    const { subject } = get(messageState)
    return subject.trim().length > 0
  }
})

export const canEditState = selector({
  key: 'overviewMessageCanEditState',
  get: ({ get }) => {
    const { isSending } = get(messageState)
    return !isSending
  }
})

export const canSaveState = selector({
  key: 'overviewMessageCanSaveState',
  get: ({ get }) => {
    const { isSending, subject } = get(messageState)

    return !isSending && subject
  }
})

export const checkupOKState = selector({
  key: 'overviewMessageCheckUpOKState',
  get: ({ get }) => {
    const { checkup } = get(messageState)

    return checkup
      ? checkup.blocking + checkup.potential + checkup.improvements === 0
      : false
  }
})

export const messageHasThumbnail = selectorFamily({
  key: 'overviewMessageHasThumbnail',
  get: id => async ({ get }) => {
    const { hasThumbnail } = get(messageState)

    if (!hasThumbnail) {
      try {
        await beMessApiGenerateThumbnail(id)
      } catch (error) {
        logAppError({ appError: error })
        throw error
      }
    }

    return true
  }
})

export const notificationState = atom({
  key: 'overviewMessageNotificationState',
  default: {
    notificationEnable: true,
    activeMessage: false
  }
})

export const collaborationState = atom({
  key: 'overviewMessageCollaborationState',
  default: []
})

export const messagesCollaborationState = selector({
  key: 'overviewMessageMessagesCollaborationState',
  get: ({ get }) => {
    const projectsIds = get(collaborationState).map(
      idMessage => `NL_${idMessage}`
    )

    return projectsIds.length
      ? collaborationApiGetAccountProjects(
          [
            COLLABORATION_PROJECT_STATUS_OPEN,
            COLLABORATION_PROJECT_STATUS_APPROVED,
            COLLABORATION_PROJECT_STATUS_ARCHIVED
          ],
          projectsIds
        )
      : Promise.resolve({ Items: [] })
  }
})

export const attachmentsState = atom({
  key: 'overviewMessageAttachmentsState',
  default: {
    attachments: [],
    attachmentsMetadata: []
  }
})

export const canUploadState = selector({
  key: 'overviewMessageCanUploadState',
  get: ({ get }) => {
    const { attachments } = get(attachmentsState)
    return attachments.length < MESSAGE_MAX_ATTACHMENTS
  }
})

export const footerState = atom({
  key: 'overviewMessageFooterState',
  default: {
    data: '',
    dataTooltip: '',
    isCompleted: false,
    isCompletedAfterInit: false,
    state: 'loading'
  }
})

export const hasWelcomeSeriesState = atom({
  key: 'overviewMessageHasWelcomeSeriesState',
  default: false
})
